// @flow
import type {Element} from 'react'
import React from 'react'

import type {MoveItemsOptionMap, UpdateCallback} from 'components/proposals/types'
import {Checkbox} from 'components/proposals/Part/ui'

import MoveItems from '../MoveItems'

type Props = $ReadOnly<{
  changeKey: string,
  roleName: string,
  destroyRole: boolean,
  expandRole: boolean,
  isNew: boolean,
  isReadonly: boolean,
  onChange: UpdateCallback,
  policiesToMoveDown: MoveItemsOptionMap,
  rolesToMoveDown: MoveItemsOptionMap,
}>

function RoleV4Footer(props: Props): Element<"div"> {
  const {
    changeKey,
    destroyRole,
    expandRole,
    isNew,
    isReadonly,
    onChange,
  } = props

  return (
    <div className="refinery-role-footer">
      <div className="refinery-role-footer__expand-role-checkbox">
        <Checkbox
          id={`${changeKey}-make-role-a-circle`}
          checked={expandRole}
          disabled={isReadonly || destroyRole}
          label={I18n.t('proposals.role_edit.make_role_circle')}
          onChange={onChange}
          path={['expandRole']}
          tabIndex={0}
        />
      </div>
      {!isNew && (
        <div className="refinery-role-footer__destroy-role-checkbox">
          <Checkbox
            checked={destroyRole}
            disabled={isReadonly || expandRole}
            label={I18n.t('proposals.role_edit.remove_role')}
            onChange={onChange}
            path={['destroyRole']}
            tabIndex={0}
          />
        </div>
      )}
      {expandRole && (
        <div className="refinery-role-footer__move-items">
          <MoveItems
            changeKey={changeKey}
            isReadonly={isReadonly}
            onChange={onChange}
            roleName={props.roleName}
            policiesToMoveDown={props.policiesToMoveDown}
            rolesToMoveDown={props.rolesToMoveDown}
          />
        </div>
      )}
    </div>
  )
}

RoleV4Footer.defaultProps = {
  expandRole: false,
  destroyRole: false,
  isReadonly: false,
}

export default RoleV4Footer
